import { Dispatch, SetStateAction } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const ModalInfoTriseries = ({ isOpen, setIsOpen }: Props) => {
  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} fullWidth>

      <DialogTitle className='flex justify-center text-orangeTr4iner'> Triserie </DialogTitle>

      <DialogContent className='font-medium' dividers>
        Se refiere a realizar un ejercicio seguido de otro, sin descanso entre ellos, únicamente al terminar los tres ejercicios se descansa de 60 a 90 seg.
      </DialogContent>

      <DialogActions>
        <button
          onClick={() => setIsOpen(false)}
          className="text-white bg-black p-2 rounded-lg"
        >
          Cerrar
        </button>
      </DialogActions>

    </Dialog>
  )
}

export default ModalInfoTriseries;
